'use client';

import { useDictionary } from '@/context/DictionaryContext';
import { useMedia } from '@/context/MediaContext';
import styles from '@/styles/components/LiveTVEmbed.module.scss';

const LiveTVEmbed = ({ outlet, lang, title }: { outlet: string, lang: string, title?: string }) => {
  const dictionary = useDictionary();
  const { state } = useMedia();

  if (title && state.isVisible) return null;

  return (
    <>
      <div className="widget">
        <div className={styles.LiveTVEmbed}>
          {title && <h3 className={styles.title}>{dictionary.t('widget.live.title')}</h3>}
          <iframe
            src={`${process.env.OTT_PROVIDER}/tv?lang=${lang}`}
            title="Live TV"
            width="100%"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            style={{ aspectRatio: "16 / 9", display: "flex" }}
            allowFullScreen />
        </div>
      </div>
    </>
  )
}

export default LiveTVEmbed;